import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { reduxForm, Field, getFormValues } from 'redux-form'
// @ts-ignore
import {
  ToggleSwitch,
  // @ts-ignore
} from 'relevant-ui'
import '../form.scss'
import { Fields } from './types'
import InputField from '@App/components/fields/InputField'
import ButtonWrapper from '@App/components/blocks/UiPage/Button'
import FormatText from '@App/helpers/formatText'

class OrganizationForm extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      segmentList: [],
    }

    this.handleToggle = this.handleToggle.bind(this)
  }

  componentDidMount() {
    const { current } = this.props

    let curentSegmentList: any = []
    current?.app?.map((el: any) => {
      return el.segments?.map((seg: any) => {
        return (curentSegmentList = [...curentSegmentList, seg.id])
      })
    })

    this.setState({ segmentList: curentSegmentList })
  }

  componentDidUpdate(prevProps) {
    const { current } = this.props
    const { current: prevCurrent } = prevProps

    if (current !== prevCurrent) {
      let curentSegmentList: any = []
      current?.app?.map((el: any) => {
        return el.segments.map((seg: any) => {
          return (curentSegmentList = [...curentSegmentList, seg.id])
        })
      })

      this.setState({ segmentList: curentSegmentList })
      return
    }
  }

  handleToggle(bool, seg) {
    const { segmentList } = this.state
    if (bool) {
      this.setState({ segmentList: [...segmentList, seg.id] })

      return
    }

    this.setState({
      segmentList: segmentList.filter((el: any) => el !== seg.id),
    })

    return
  }

  render() {
    const {
      toggle,
      t,
      handleCanceled,
      handleDelete,
      appList,
      handleSubmit,
      orgFormValues,
    } = this.props
    const { segmentList } = this.state

    const list = appList?.filter((item: any) => item.name !== 'Retargeting')

    return (
      <form className="form form__connect">
        <div className="form__wrapper">
          <section className="formWrapper">
            <h4 className="formWrapper__title">{t('informations')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('Name')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.NAME}
                    component={InputField}
                    label="Name"
                    placeholder="Name..."
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="formWrapper formWrapper--noBorder">
            <h4 className="formWrapper__title mb-20">{t('Segments')}</h4>
            <div className="formWrapper__container formWrapper__container--organizations">
              {list?.map((el: any, index: number) => {
                if (el?.segments?.length !== 0) {
                  return (
                    <section
                      key={`${el.name}__${index}`}
                      className="segments__wrapper"
                    >
                      <h2 className="segments__title">{el.name}</h2>
                      <div className="segments__items">
                        {el?.segments?.map((seg: any, index: number) => {
                          const defaultValue = segmentList.find(
                            (item: any) => item === seg.id,
                          )
                            ? true
                            : false

                          return (
                            <div
                              key={`${seg.name}__${index}`}
                              className="segments__item"
                            >
                              <ToggleSwitch
                                default={defaultValue}
                                label={seg.name}
                                onClick={(e) => {
                                  this.handleToggle(e, seg)
                                }}
                                disabled={toggle}
                              />
                            </div>
                          )
                        })}
                      </div>
                    </section>
                  )
                }
                return
              })}
            </div>
          </section>
        </div>
        <ButtonWrapper
          onCancel={handleCanceled}
          onSubmit={handleSubmit}
          onDelete={handleDelete}
          dataTable={segmentList}
          disabled={orgFormValues && Object.keys(orgFormValues)?.length !== 1}
        />
      </form>
    )
  }
}

const NewOrganizationForm = reduxForm({
  form: Fields.FORM,
  enableReinitialize: true,
})(OrganizationForm as any)

const mapStateToProps = (state: any) => {
  const orgFormValues = getFormValues(Fields.FORM)(state)
  const {
    applications: { list },
    organizations: { current },
    toggleFields: { toggle },
  } = state

  let initialValues = {}

  if (current) {
    initialValues = {
      [Fields.NAME]: current.title || '',
    }
  }

  return {
    current,
    toggle,
    initialValues,
    orgFormValues,
    appList: list,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(NewOrganizationForm)
